// Helper tampilan nilai confidence ke persen.
export const formatConfidence = (value) => {
  if (typeof value !== "number") return "-";
  // Jika 0..1 anggap rasio, kalau >1 anggap sudah persen.
  const pct = value <= 1 ? value * 100 : value;
  return `${pct.toFixed(0)}%`;
};

// Helper capitalize severity.
export const capitalize = (value) => {
  if (typeof value !== "string" || !value) return "-";
  return value.charAt(0).toUpperCase() + value.slice(1);
};

// Map severity -> warna badge reactstrap.
export const severityColor = (value) => {
  switch ((value || "").toLowerCase()) {
    case "high":
      return "danger";
    case "medium":
      return "warning";
    case "low":
      return "info";
    default:
      return "secondary";
  }
};

// Map verified_by_AI -> { color, label } untuk status audit tryout.
export const auditStatusBadge = (value) => {
  switch ((value || "none").toLowerCase()) {
    case "process":
      return { color: "warning", label: "Auditing" };
    case "done":
      return { color: "success", label: "Selesai" };
    case "failed":
      return { color: "danger", label: "Error" };
    default:
      return { color: "secondary", label: "Belum" };
  }
};